/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../wire/ApiCaller";
import type {
  CreateSessionRequest,
  CreateSessionResponse,
  CreateTemplateSessionRequest,
  CreateTemplateSessionResponse,
  GetCompanyStatsResponse,
  GetSessionsOfArtsRequest,
  GetSessionsResponse,
  GetTemplateSessionsResponse,
  GetUsersSeeAllSessionsResponse,
  NoData,
  SetUsersSeeAllSessionsRequest,
  SetUsersSeeAllSessionsResponse,
} from "./models";
import {
  createSessionResponseSchema,
  createTemplateSessionResponseSchema,
  getCompanyStatsResponseSchema,
  getSessionsResponseSchema,
  getTemplateSessionsResponseSchema,
  getUsersSeeAllSessionsResponseSchema,
  noDataSchema,
  setUsersSeeAllSessionsResponseSchema,
} from "./schemas";

export class CompanyApiClient {
  constructor(private caller: ApiCaller) {}

  async createTemplateSession(
    payload: CreateTemplateSessionRequest,
    timeout?: number,
  ): Promise<CreateTemplateSessionResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.company.v1.template_sessions.create",
        variables: {},
      },
      "createTemplateSession",
      payload,
      { schema: createTemplateSessionResponseSchema, timeout },
    );
  }

  async createCompany(timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.company.v1.companies.create",
        variables: {},
      },
      "createCompany",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async deleteCompany(timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.company.v1.companies.delete",
        variables: {},
      },
      "deleteCompany",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async getStats(timeout?: number): Promise<GetCompanyStatsResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.company.v1.stats.get",
        variables: {},
      },
      "getStats",
      {},
      { schema: getCompanyStatsResponseSchema, timeout },
    );
  }

  async getUsersSeeAllSessions(timeout?: number): Promise<GetUsersSeeAllSessionsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.company.v1.settings.users_see_all_sessions.get",
        variables: {},
      },
      "getUsersSeeAllSessions",
      {},
      { schema: getUsersSeeAllSessionsResponseSchema, timeout },
    );
  }

  async setUsersSeeAllSessions(
    payload: SetUsersSeeAllSessionsRequest,
    timeout?: number,
  ): Promise<SetUsersSeeAllSessionsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.company.v1.settings.users_see_all_sessions.set",
        variables: {},
      },
      "setUsersSeeAllSessions",
      payload,
      { schema: setUsersSeeAllSessionsResponseSchema, timeout },
    );
  }

  async getSessionsOfTeam(teamId: number, timeout?: number): Promise<GetSessionsResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.company.v1.teams.${teamId}.sessions.get",
        variables: { teamId: String(teamId) },
      },
      "getSessionsOfTeam",
      {},
      { schema: getSessionsResponseSchema, timeout },
    );
  }

  async getSessionsOfArts(
    payload: GetSessionsOfArtsRequest,
    timeout?: number,
  ): Promise<GetSessionsResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.company.v1.arts.sessions.get",
        variables: {},
      },
      "getSessionsOfArts",
      payload,
      { schema: getSessionsResponseSchema, timeout },
    );
  }

  async getSessionsOfSolutionTrain(
    solutionTrainId: number,
    timeout?: number,
  ): Promise<GetSessionsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.company.v1.solution_trains.${solutionTrainId}.sessions.get",
        variables: { solutionTrainId: String(solutionTrainId) },
      },
      "getSessionsOfSolutionTrain",
      {},
      { schema: getSessionsResponseSchema, timeout },
    );
  }

  async createSession(
    payload: CreateSessionRequest,
    timeout?: number,
  ): Promise<CreateSessionResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.company.v1.sessions.create",
        variables: {},
      },
      "createSession",
      payload,
      { schema: createSessionResponseSchema, timeout },
    );
  }

  async getTemplateSessions(timeout?: number): Promise<GetTemplateSessionsResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.company.v1.template_sessions.get",
        variables: {},
      },
      "getTemplateSessions",
      {},
      { schema: getTemplateSessionsResponseSchema, timeout },
    );
  }
}
